const FORMAT_STRING = 'data_url'

export default FORMAT_STRING
